import type { ComponentProps } from "react";
import { ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

type ButtonSize = NonNullable<ComponentProps<typeof Button>["size"]>;
type ButtonVariant = NonNullable<ComponentProps<typeof Button>["variant"]>;

interface InviteSplitButtonProps {
  primaryLabel: string;
  secondaryLabel: string;
  onPrimaryAction: () => void;
  onSecondaryAction: () => void;
  disabled?: boolean;
  size?: ButtonSize;
  variant?: ButtonVariant;
  className?: string;
}

export function InviteSplitButton({
  primaryLabel,
  secondaryLabel,
  onPrimaryAction,
  onSecondaryAction,
  disabled = false,
  size = "sm",
  variant = "default",
  className,
}: InviteSplitButtonProps) {
  return (
    <div className={cn("flex shrink-0 items-center", className)}>
      <Button
        type="button"
        size={size}
        variant={variant}
        className="rounded-r-none"
        disabled={disabled}
        onClick={onPrimaryAction}
      >
        {primaryLabel}
      </Button>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            type="button"
            size={size}
            variant={variant}
            className="rounded-l-none border-l border-black/10 px-2 dark:border-white/15"
            disabled={disabled}
            aria-label="More invite actions"
          >
            <ChevronDown className="size-3.5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onClick={onSecondaryAction}>
            {secondaryLabel}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
